import request from "../Config/axios";
// -----------------------------------------------------------
export const GetAll_Category_Api = async (params) => {
    const { data } = await request.post(
        `/Category/GetAll/`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_WithPrice_Category_Api = async () => {
    const { data } = await request.get(
        `/Category/GetAll_WithPrice/`
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_WithPeriod_Category_Api = async () => {
    const { data } = await request.get(
        `/Category/GetAll_WithPeriod/`
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_WithFood_Category_Api = async () => {
    const { data } = await request.get(
        `/Category/GetAll_WithFood/`
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_WithParking_Category_Api = async () => {
    const { data } = await request.get(
        `/Category/GetAll_WithParking/`
    );
    return data;
};
// -----------------------------------------------------------
export const Add_Category_Api = async (params) => {
    const { data } = await request.post(
        `/Category/Add`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetById_Category_Api = async (id) => {
    const { data } = await request.get(
        `/Category/GetById/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const Update_Category_Api = async (params) => {
    const { data } = await request.post(
        `/Category/Update`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Delete_Category_Api = async (id) => {
    const { data } = await request.delete(
        `/Category/Delete/?id=` + id,
    );
    return data;
};
// -----------------------------------------------------------
export const IsInCategory_Category_Api = async (params) => {
    const { data } = await request.post(
        `/Category/IsInCategory`,
        params
    );
    return data;
};
// -----------------------------------------------------------
